const DEFAULT_THEME = {
  border: "#FFD700",
  background: "rgba(255,215,0,0.2)",
};

const metalThemes = {
  AI:  {
    border: "#253339ff",
    background: "rgba(26, 58, 187, 0.58)",
  },

  U: {
    border: "#cdb31bff",
    background: "rgba(200, 165, 51, 0.6)",
  },
  
  Cu: {
    border: "#C87533",
    background: "rgba(200,117,51,0.2)",
  },

  // Future ready:
  // Au: {
  //   border: "#D4AF37",
  //   background: "rgba(212,175,55,0.2)",
  // },
};

export { metalThemes, DEFAULT_THEME };